import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from "redux";
import { connect } from 'react-redux';
import { selectExperience } from "../../redux/actions";
import { HotelParamsLine, DropdownContainer } from "../index";
import { Checkbox } from "../../components";
import { slugify, getCategory } from '../../utils';
import { Router } from "../../routes";

const { ParamsOption, CheckboxList } = HotelParamsLine;

const mapStateToProps = state => ({
  experience: state.userPreferences.experience,
  product: state.userPreferences.product,
  market: state.userPreferences.city.market,
});

const mapDispatchToProps = dispatch => bindActionCreators({
  handleExperienceSelection: selectExperience,
}, dispatch);

@connect(mapStateToProps, mapDispatchToProps)
class ExperienceSelector extends Component {
  static propTypes = {
    experience: PropTypes.string,
    handleExperienceSelection: PropTypes.func,
    currentDropdown: PropTypes.string,
    handleDropdownClick: PropTypes.func,
    handleCloseDropdown: PropTypes.func,
    product: PropTypes.string,
    market: PropTypes.string,
  };

  getExperienceTitle = option => {
    const splitOptions = option.split(',');
    let optionsMessage;

    if (splitOptions.length > 1) {
      optionsMessage = `${splitOptions.length} options selected`;
    } else {
      optionsMessage = splitOptions;
    }

    return optionsMessage;
  };

  handleCheckboxSelect = evt => {
    const { handleExperienceSelection, product, market } = this.props;
    const { target } = evt;
    let checkboxOptions;

    if (Router.query.experience) {
      checkboxOptions = Router.query.experience.split(',');
    } else {
      checkboxOptions = [];
    }

    const containedOptionIndex = checkboxOptions.findIndex(
      option => option.trim() === target.value,
    );

    if (containedOptionIndex !== -1) {
      checkboxOptions.splice(containedOptionIndex, 1);
    } else {
      checkboxOptions.push(target.value);
    }

    const filteredCheckboxOptions = checkboxOptions.filter(option => option.length !== 0);
    const experience = filteredCheckboxOptions.join(',');

    Router.pushRoute('search', {
      ...Router.query,
      marketName: slugify(market),
      category: getCategory(product),
      experience,
    }, { shallow: true });

    handleExperienceSelection(experience);
  };

  render() {
    const { getExperienceTitle, handleCheckboxSelect } = this;
    const { currentDropdown, handleDropdownClick, handleCloseDropdown, experience } = this.props;

    return (
      <Fragment>
        <ParamsOption
          type="button"
          name="experience"
          onClick={handleDropdownClick}
          isOpened={currentDropdown === 'experience'}
          isActive={experience.length !== 0}
        >
          {experience.length !== 0 ? getExperienceTitle(experience) : 'Experience Type'}
        </ParamsOption>
        {currentDropdown === 'experience' && (
          <DropdownContainer
            name="experience"
            handleCloseButtonClick={handleCloseDropdown}
            onClickOutside={handleCloseDropdown}
          >
            <CheckboxList onChange={handleCheckboxSelect}>
              <li>
                <Checkbox
                  readonly
                  description="Lively vibe, upbeat poolside music, social events and pool parties"
                  name="Festive"
                  value="Festive"
                  checked={experience.includes('Festive')}
                  id="Festive"
                  label="Festive"
                />
              </li>
              <li>
                <Checkbox
                  readonly
                  description="Kids programs, child-friendly features, water parks"
                  name="Family"
                  value="Family"
                  checked={experience.includes('Family')}
                  id="Family"
                  label="Family"
                />
              </li>
              <li>
                <Checkbox
                  readonly
                  description="A calm and peaceful vibe to relax and recharge"
                  name="Tranquil"
                  value="Tranquil"
                  checked={experience.includes('Tranquil')}
                  id="Tranquil"
                  label="Tranquil"
                />
              </li>
            </CheckboxList>
          </DropdownContainer>
        )}
      </Fragment>
    );
  }
}

export default ExperienceSelector;
